function showZenWidget(delay) {
  setTimeout(function () {
    $('body').addClass('show-zen-widget');
  }, delay);
}

$(document).ready(function () {

  var delay = 5000;
  var currentPath = window.location.pathname;
  console.log(currentPath);

  // Check if Cookie Consent banner is open
  // If it is - do not show the chat widget
  if ($('#cookie-consent').is(':hidden')) {

    // Check current page should show widget
    if (currentPath.includes('faqs') || currentPath.includes('account')) {
      showZenWidget(0);
    } else {
      showZenWidget(delay);
    }
    
  } 

});